import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var ErrorIcon = function ErrorIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "ErrorIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m2.475 5.737 3.262-3.262h4.546l3.262 3.262v4.546l-3.262 3.262H5.737l-3.262-3.262zm3.24-4.712c-.19 0-.38.032-.564.115-.182.08-.324.194-.436.306l-3.27 3.27a1.4 1.4 0 0 0-.305.435 1.4 1.4 0 0 0-.115.564v4.59c0 .19.032.38.115.564.08.182.194.324.306.436l3.269 3.269c.112.112.254.226.436.306.185.083.375.115.564.115h4.59c.19 0 .379-.032.564-.115.182-.08.323-.194.436-.306l3.269-3.27c.112-.111.225-.253.306-.435a1.4 1.4 0 0 0 .115-.564v-4.59a1.4 1.4 0 0 0-.115-.564 1.5 1.5 0 0 0-.306-.436l-3.27-3.269a1.4 1.4 0 0 0-.435-.306 1.4 1.4 0 0 0-.564-.115zM8 4.2a.8.8 0 0 1 .8.8v3a.8.8 0 1 1-1.6 0V5a.8.8 0 0 1 .8-.8M9 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0",
      clipRule: "evenodd"
    })
  }));
};

export { ErrorIcon };
